import i18n from 'i18next';
import { RACING_SPORT_IDS } from 'utils/constants/sportsbook/racing-sport';
import { Game, Sport } from 'interfaces/sportsbook-data-levels';

export const CUSTOM_OTHERS_GROUP_ID = 999999;

export const setMissingMarketGroupNameOther = (swarmData: {
  sport: Record<string, Sport>;
}): { sport: Record<string, Sport<Game>> } => {
  const data = JSON.parse(JSON.stringify(swarmData));

  if (
    data?.sport &&
    Object.values(data.sport).length &&
    Object.values(data.sport)[0]
  ) {
    for (const sport in data.sport) {
      if (!RACING_SPORT_IDS.includes(+data.sport[sport].id)) {
        const regions = data.sport[sport].region;

        for (const region in regions) {
          const competitions = regions[region].competition;

          for (const competition in competitions) {
            const games = competitions[competition].game;

            for (const game in games) {
              const markets = games[game].market;

              for (const market in markets) {
                if (markets[market]) {
                  markets[market].group_id =
                    markets[market]?.group_id || CUSTOM_OTHERS_GROUP_ID;
                  markets[market].group_name =
                    markets[market].group_name || i18n.t('generic.other');
                }
              }
            }
          }
        }
      }
    }
  }

  return data;
};
